/* eslint-disable import/no-named-as-default */

import { ROOT_SLICE } from './constants';
import {
  setSearchText,
  setIsInitialized,
  clear
} from './actions';
import { selectThisSlice } from './selectors';

// ************
// PARTS
// ************
const reducerParts = {
  [clear]: state => {
    const rootSlice = selectThisSlice(state);

    return {
      ...state,
      [ROOT_SLICE]: {
        ...rootSlice,
        searchText: '',
        isFuzzySearch: false,
      }
    };
  },

  [setSearchText]: (
    state,
    { payload: { searchText, isFuzzySearch } }
  ) => {
    const rootSlice = selectThisSlice(state);
    const _isFuzzySearch = !!(isFuzzySearch && searchText && searchText.trim().length);

    return {
      ...state,
      [ROOT_SLICE]: {
        ...rootSlice,
        searchText,
        isFuzzySearch: _isFuzzySearch
      }
    };
  },

  [setIsInitialized]: (
    state,
    { payload: { isInitialized } }
  ) => {
    const rootSlice = selectThisSlice(state);

    return {
      ...state,
      [ROOT_SLICE]: {
        ...rootSlice,
        isInitialized: !!isInitialized,
      }
    };
  },
};


export default reducerParts;
